import DefaultModal from "../pages/company/CompanySettings/JobApproval/component/dialog";

interface ConfirmDeleteModalProps {
  open: boolean;
  title?: string;
  entityName?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const ConfirmDeleteModal = ({
  open,
  title = "Confirm Delete",
  entityName,
  description,
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  onCancel,
  onConfirm,
  loading = false,
}: ConfirmDeleteModalProps) => {
  return (
    <DefaultModal
      open={open}
      onClose={onCancel}
      className="w-full max-w-sm sm:max-w-md mx-4"
    >
      <div className="p-4 sm:p-6 space-y-4">
        <h3 className="text-base sm:text-lg font-semibold text-red-600">
          {title}
        </h3>

        <p className="text-sm text-gray-600 leading-relaxed">
          {description ?? (
            <>
              Are you sure you want to delete{" "}
              <span className="font-semibold text-gray-900">
                {entityName ? `“${entityName}”` : "this item"}
              </span>
              ?
            </>
          )}
        </p>

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
          <button
            className="px-4 py-2 border rounded"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </button>

          <button
            className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : confirmText}
          </button>
        </div>
      </div>
    </DefaultModal>
  );
};
